// extracted by mini-css-extract-plugin
export var menuIcon = "_p3-0";
export var menuIconInline = "_p3-1";